import {
  tradeWebsocketURL as defaultTradeWebsocketURL,
  contractWebsocketURL as defaultContractWebsocketURL,
} from '@/config'
import { localCache } from '@hotcoin/utils/dist/utils/cache'

interface EndpointConfig {
  contractWS?: string
  tradeWS?: string
}

interface WebSocketURLs {
  contractWsURL: string
  tradeWsURL: string
}

/**
 * 获取 WebSocket 连接 URL 的自定义 Hook
 * @returns {WebSocketURLs} 包含合约和交易 WebSocket URL 的对象
 * @description
 * - 优先从本地缓存获取 endpoint 配置
 * - 如果缓存中存在配置，则使用缓存的地址构建 WebSocket URL
 * - 如果没有缓存或在服务端环境，则使用默认配置
 */
export const useWebSocketURL = (): WebSocketURLs => {
  // 初始化默认值
  const urls: WebSocketURLs = {
    contractWsURL: defaultContractWebsocketURL,
    tradeWsURL: defaultTradeWebsocketURL,
  }

  // 服务端渲染时直接返回默认值
  if (typeof window === 'undefined') {
    return urls
  }

  // 获取缓存的 endpoint 配置
  const endpoint = localCache.getCache('endpoint') as EndpointConfig | null

  // 如果存在缓存的合约 WebSocket 地址，更新 contractWsURL
  if (endpoint?.contractWS) {
    urls.contractWsURL = `wss://${endpoint.contractWS}`
  }

  // 如果存在缓存的交易 WebSocket 地址，更新 tradeWsURL
  if (endpoint?.tradeWS) {
    urls.tradeWsURL = `wss://${endpoint.tradeWS}/trade/multiple`
  }

  return urls
}
